import {remCalc} from '../../_utils'

export default {
    baseStyle: ({basketLength}: {basketLength: number}) => ({
        subscriptionsContainer: {
            display: 'flex',
            flexDir: 'column',
            paddingX: remCalc(24),
            paddingY: remCalc(16),
            borderRadius: 'large-1',
            bg: 'background.base.over',
            boxShadow:
                '0 0 0 1px var(--chakra-colors-border-neutral-highlight) inset, 0 1px 2px 0 var(--chakra-shadows-neutral-xs), 0 0 0 1px var(--chakra-shadows-neutral-xs)',
            mb: remCalc(8),
        },
        errorText: {
            textStyle: 'body-xxsmall',
            color: 'text.danger',
            mt: remCalc(4),
        },
        subscriptionsTextsContainer: {
            alignItems: 'center',
        },
        subscriptionsText: {
            textStyle: 'body-small',
            fontWeight: 'normal',
            color: 'foreground.neutral.default',
            ml: remCalc(8),
        },
        subscriptionsLink: {
            textStyle: 'body-small',
            fontWeight: 'bold',
            textDecoration: 'underline',
            color: 'foreground.neutral.default',
            cursor: 'pointer',
            ml: remCalc(4),
        },
        orderSummaryBox: {
            w: {base: '100%'},
        },
        summaryContainer: {
            display: 'flex',
            padding: {base: 'xsmall.base', md: 'xsmall.md', lg: 'xsmall.lg', xl: 'xsmall.xl'},
            gap: remCalc(0),
            flexDir: 'column',
            borderRadius: 'xl-1',
            bg: 'background.base.over',
            minWidth: {lg: 'unset', xl: remCalc(451)},
        },
        innerSummaryContainer: {
            paddingBottom: {base: 'small.base', md: 'small.md', lg: 'small.lg', xl: 'small.xl'},
        },
        summaryDetailsContainer: {
            flexDir: 'column',
            gap: {
                base: 'xxsmall-1.base',
                md: 'xxsmall-1.md',
                lg: 'xxsmall-1.lg',
                xl: 'xxsmall-1.xl',
            },
            alignItems: 'center',
            justifyContent: 'center',
        },
        mobileOrderReviewOuterContainer: {
            display: {base: 'block', lg: 'none'},
            width: '100%',
            mx: 'auto',
            bgColor: 'background.base.over',
            borderRadius: 'xl-1',
        },
        mobileOrderReviewContainer: {
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            padding: remCalc(16),
            cursor: 'pointer',
        },
        promo: {
            promoContainer: {
                display: 'flex',
                flexDir: 'column',
                gap: {
                    base: 'xxsmall-1.base',
                    md: 'xxsmall-1.md',
                    lg: 'xxsmall-1.lg',
                    xl: 'xxsmall-1.xl',
                },
                marginBottom: {base: 'small.base', md: 'small.md', lg: 'small.lg', xl: 'small.xl'},
                width: 'full',
            },
            referralLinkContainer: {
                display: 'flex',
                flexDir: 'row',
                alignItems: 'center',
                justifyContent: 'flex-start',
                gap: remCalc(4),
            },
            referralLinkText: {
                textStyle: 'body-small',
                fontWeight: 'normal',
                color: 'foreground.neutral.subtle',
            },
            inputContainer: {
                width: 'full',
                display: 'flex',
                paddingX: {base: 'xsmall.base', md: 'xsmall.md', lg: 'xsmall.lg', xl: 'xsmall.xl'},
                paddingY: {
                    base: 'xxsmall-1.base',
                    md: 'xxsmall-1.md',
                    lg: 'xxsmall-1.lg',
                    xl: 'xxsmall-1.xl',
                },
                flexDir: 'column',
                borderRadius: 'large-1',
                bg: 'background.base.elevated',
                boxShadow:
                    '0 0 0 1px var(--chakra-colors-border-neutral-highlight) inset, 0 1px 2px 0 var(--chakra-shadows-neutral-xs), 0 0 0 1px var(--chakra-shadows-neutral-xs)',
            },
            inputContainerHeader: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',

                _hover: {
                    bg: 'background.base.elevated',
                },
            },
            inputContainerHeaderContent: {
                flexDir: 'row',
                alignItems: 'center',
                gap: remCalc(8),
            },
            inputContainerHeaderIcon: {
                width: remCalc(14),
                height: remCalc(14),
                color: 'foreground.neutral.default',
            },
            inputContainerHeaderText: {
                marginBottom: remCalc(0),
                textStyle: 'body-small',
                fontWeight: 'medium',
                color: 'foreground.neutral.default',
            },
            inputAndButtonContainer: {
                paddingY: remCalc(2),
            },
            inputAccordionButtonText: {
                textStyle: 'body-small',
                fontWeight: 'medium',
                color: 'foreground.neutral.default',
            },
            inputAccordionButtonIcon: {
                width: remCalc(10),
                height: remCalc(10),
                color: 'foreground.neutral.default',
            },
            inputContainerPanel: {
                display: 'flex',
                pt: remCalc(0),
                marginTop: remCalc(0),
                flexDir: 'column',
                gap: {base: 'xsmall.base', md: 'xsmall.md', lg: 'xsmall.lg', xl: 'xsmall.xl'},
            },
            inputCodesForYouAccordion: {
                paddingTop: {
                    base: 'xsmall.base',
                    md: 'xsmall.md',
                    lg: 'xsmall.lg',
                    xl: 'xsmall.xl',
                },
            },
            inputCodesForYouContainer: {
                flexDir: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: remCalc(8),
                // bg: '#E1E1E3',
                bg: 'transparent',
                border: '1px dashed var(--chakra-colors-border-neutral-default)',
                padding: {
                    base: 'xxsmall-1.base',
                    md: 'xxsmall-1.md',
                    lg: 'xxsmall-1.lg',
                    xl: 'xxsmall-1.xl',
                },
                borderRadius: 'large',
            },
            inputCodesForYouAccordionHeader: {
                paddingBottom: `${remCalc(2)} !important`,
                paddingTop: `${remCalc(2)} !important`,
                paddingX: `${remCalc(2)} !important`,
                borderRadius: 'large',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: remCalc(8),
            },
            inputCodesForYouTextContainer: {
                flexDir: 'column',
                alignItems: 'flex-start',
                justifyContent: 'flex-start',
            },
            inputCodesForYouTitle: {
                textStyle: 'body-small',
                fontWeight: 'medium',
                color: 'foreground.neutral.default',
            },
            inputCodeTitle: {
                textStyle: 'body-xsmall',
                fontWeight: 'medium',
                color: 'foreground.neutral.default',
            },
            inputCodeDescription: {
                textStyle: 'body-xsmall',
                fontWeight: 'regular',
                color: 'foreground.neutral.muted',
            },
            promoAppliedOuterContainer: {
                display: 'flex',
                flexDir: 'row',
                width: '100%',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: remCalc(12),
            },
            promoAppliedTitle: {
                textStyle: 'body-small',
                fontWeight: 'regular',
                color: 'foreground.neutral.default',
            },
            promoAppliedContainer: {
                display: 'flex',
                flexDir: 'row',
                width: 'fit-content',
                alignItems: 'center',
                justifyContent: 'center',
                paddingX: remCalc(8),
                paddingY: remCalc(6),
                gap: remCalc(8),
                borderRadius: 'large',
                bg: 'background.base.over',
                boxShadow:
                    '0 0 0 1px var(--border-neutral-highlight, #FFF) inset, 0 1px 2px 0 var(--neutral-xs, rgba(19, 24, 58, 0.08)), 0 0 0 1px var(--neutral-xs, rgba(19, 24, 58, 0.08))',
            },
            appliedPromoText: {
                textStyle: 'body-xsmall',
                fontWeight: 'medium',
                color: 'foreground.neutral.default',
            },
            removePromoIcon: {
                width: remCalc(14),
                height: remCalc(14),
                color: 'foreground.neutral.default',
                cursor: 'pointer',
            },
        },
        zipCode: {
            zipCodeContainer: {
                width: 'full',
                display: 'flex',
                flexDir: 'column',
                gap: {
                    base: 'xxsmall-1.base',
                    md: 'xxsmall-1.md',
                    lg: 'xxsmall-1.lg',
                    xl: 'xxsmall-1.xl',
                },
                justifyContent: 'center',
                alignItems: 'flex-start',
            },
            zipCodeText: {
                textStyle: 'body-small',
                color: 'foreground.neutral.default',
                fontWeight: 'normal',
            },
            zipCodeTaxPreviewAmount: {
                textStyle: 'body-small',
                color: 'foreground.neutral.default',
                fontWeight: 'medium',
            },
            plusIcon: {
                width: remCalc(10),
                height: remCalc(10),
                color: 'foreground.neutral.default',
            },
            zipCodeInputClearButton: {
                paddingTop: remCalc(8),
                paddingBottom: remCalc(8),
                paddingInlineStart: remCalc(8),
                paddingInlineEnd: remCalc(8),
            },
            zipCodeInputClearIcon: {
                width: remCalc(16),
                height: remCalc(16),
                color: 'foreground.neutral.default',
            },
            zipCodeEdit: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            },
            zipCodeEditIcon: {
                boxSize: 'iconsSize.small',
            },
            zipCodeEditContainer: {
                alignItems: 'center',
                justifyContent: 'flex-end',
                gap: remCalc(4),
            },
            zipCodeInfoContainer: {
                gap: remCalc(8),
                alignItems: 'center',
            },
            zipCodeOuterContainer: {
                flexDir: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                w: '100%',
            },
            zipInputContainer: {
                display: 'flex',
                flexDir: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: {
                    base: 'xsmall.base',
                    md: 'xsmall.md',
                    lg: 'xsmall.lg',
                    xl: 'xsmall.xl',
                },
                w: '100%',
            },
            zipCodeInputFieldContainer: {
                flex: 1,
                position: 'relative',
            },
            zipCodeApplyInputRightElement: {
                h: '100%',
                width: remCalc(84),
                right: remCalc(2),
                pointerEvents: 'auto',
            },
            zipCodeApplyButton: {
                height: remCalc(32),
                width: remCalc(72),
            },
        },
        summaryHeader: {
            itemContainer: {
                display: 'flex',
                alignItems: 'center',
                gap: remCalc(10),
                alignSelf: 'stretch',
            },
            headerText: {
                color: 'foreground.neutral.default',
                textStyle: 'head-xsmall',
                fontWeight: 'medium',
            },
            headerSubText: {
                color: 'foreground.neutral.subtle',
                textStyle: 'body-xsmall',
                fontWeight: 'regular',
            },
            headerPrice: {
                color: 'foreground.neutral.default',
                textStyle: 'body-large',
                fontWeight: 'regular',
            },
        },
        subtotalSection: {
            subtotalPriceContainer: {
                display: 'flex',
                flexDir: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                alignSelf: 'stretch',
            },
            subtotalPromotionContainer: {
                display: 'flex',
                flexDir: 'row',
                alignItems: 'center',
                alignSelf: 'stretch',
                gap: {
                    base: 'xxxsmall-1.base',
                    md: 'xxxsmall-1.md',
                    lg: 'xxxsmall-1.lg',
                    xl: 'xxxsmall-1.xl',
                },
            },
            subtotalContainer: {
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                alignSelf: 'stretch',
            },
            shippingContainer: {
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                alignSelf: 'stretch',
                gap: remCalc(2),
            },
            subtotalStackContainer: {
                flex: 1,
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
            },
            shippingTextContainer: {
                flexDir: 'row',
                justifyContent: 'flex-start',
                alignItems: 'center',
                width: 'fit-content',
                gap: remCalc(6),
            },
            subtotalText: {
                color: 'foreground.neutral.default',
                textStyle: 'body-small',
                fontWeight: 'regular',
            },
            subtotalPrice: {
                color: 'foreground.neutral.default',
                textStyle: 'body-small',
                fontWeight: 'medium',
            },
            freeShippingText: {
                color: 'foreground.neutral.default',
                textStyle: 'body-small',
                fontWeight: 'medium',
            },
            infoIconContainer: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '50%',
            },
            infoIcon: {
                display: 'flex',
                w: remCalc(14),
                h: remCalc(14),
                color: 'foreground.neutral.default',
                fill: 'none',
            },
            shippingEstimation: {
                color: 'foreground.neutral.subtle',
                textStyle: 'body-xsmall',
                fontWeight: 'regular',
            },
            savedAmountContainer: {
                textStyle: 'body-small',
                alignItems: 'center',
                justifyContent: 'space-between',
            },
        },
        checkoutSection: {
            checkoutContainer: {
                display: 'flex',
                paddingY: {base: 'small.base', md: 'small.md', lg: 'small.lg', xl: 'small.xl'},
                flexDir: 'row',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                alignSelf: 'stretch',
                gap: remCalc(8),
            },
            totalPriceContainer: {
                flexDirection: 'column',
                alignItems: 'flex-end',
                justifyContent: 'flex-end',
                gap: remCalc(4),
            },
            totalText: {
                color: 'foreground.neutral.default',
                textStyle: 'body-large',
                fontWeight: 'medium',
            },
            totalPrice: {
                color: 'foreground.neutral.default',
                textStyle: 'head-small',
                fontWeight: 'medium',
            },
            klarnaText: {
                color: 'text.default',
                textStyle: 'body-xsmall',
                fontWeight: 'normal',
            },
            goToCheckoutButtonContainer: {
                position: {base: 'fixed', lg: 'unset'},
                left: '0',
                bottom: '0',
                width: '100%',
                background: {base: 'background.light', lg: 'unset'},
                px: {base: 'small.base', lg: 'unset'},
                paddingBottom: {
                    base: 'xsmall-1.base',
                    md: 'xsmall-1.md',
                    lg: 'xsmall-1.lg',
                    xl: 'xsmall-1.xl',
                },
                zIndex: '3',
            },
            goToCheckout: {
                width: '100%',
                height: remCalc(56),
                textStyle: 'body-medium',
                fontWeight: 'medium',
            },
            checkoutTotalContainer: {
                display: {base: 'flex', lg: 'none'},
                pb: 'xsmall.base',
            },
            vatInCheckoutButton: {
                textStyle: 'body-xxsmall',
                pl: 'xsmall.base',
                alignSelf: 'center',
            },
            warrantySubsLinksAndPayementMethodsContainer: {
                display: 'flex',
                flexDir: 'column',
                gap: {base: 'small.base', md: 'small.md', lg: 'small.lg', xl: 'small.xl'},
            },
            warrantySubsLinksContainer: {
                marginTop: {
                    base: 'xsmall-1.base',
                    md: 'xsmall-1.md',
                    lg: remCalc(0),
                    xl: remCalc(0),
                },
                textStyle: 'body-xsmall',
                fontWeight: 'normal',
                color: 'foreground.neutral.subtle',
            },
            warrantySubsLinks: {
                textDecoration: 'underline',
            },
        },
        cartItems: {
            container: {
                // py: remCalc(12),
                // pt: remCalc(4),
                pt: remCalc(8),
                maxHeight: remCalc(300),
                overflowY: basketLength >= 2 ? 'scroll' : 'none',
                '::-webkit-scrollbar': {
                    width: remCalc(6),
                },
                '::-webkit-scrollbar-thumb': {
                    backgroundColor: 'button.border.inverse-primary-focused',
                    borderRadius: remCalc(6.5),
                },
            },
            itemsText: {
                textStyle: 'body-small',
            },
            itemsContainer: {
                // paddingBottom: remCalc(24),
                pt: remCalc(16),
                w: '100%',
            },
            innerItemContainer: {
                // minWidth: remCalc(109),
                width: 'full',
                alignItems: 'flex-start',
                gap: remCalc(16),
                // mb: remCalc(16),
            },
            stack: {
                // width: 'full',
                gap: remCalc(16),
            },
            itemVariant: {
                textStyle: 'body-medium',
                fontWeight: 'bold',
            },
            stackContent: {
                flexDirection: 'column',
                gap: remCalc(4),
            },
            itemVariantAttributes: {
                textStyle: 'body-xsmall',
            },
            preorderLabel: {
                textStyle: 'body-xsmall',
                fontWeight: 'normal',
                color: 'text.default',
            },
        },
    }),
    variants: {
        checkout: {
            orderSummaryBox: {
                paddingBottom: remCalc(16),
                paddingX: remCalc(16),
            },
            summaryContainer: {
                paddingY: 'unset',
                paddingX: 'unset',
            },
            summaryHeader: {
                itemContainer: {
                    display: 'none',
                },
            },
            cartItems: {
                container: {
                    pb: 'unset',
                },
                itemsContainer: {
                    pt: 'unset',
                },
            },
        },
    },
}
